'use strict';

function PhoneVerificationPage() {
  this.node = null;
  this.id = null;
  this.extends = [_AccountController];
  this._history = null;
  this._isOnboardingFlow = false;

  this.init = function () {
    this._super();
    this.verifiedSection = $('.form-wizard__success', this.node);
    $('#PhoneVerification__steps', this.node).mogo().create('PhoneVerification', {
      onComplete: $.proxy(this._onComplete, this),
      onInit: $.proxy(this.initPage, this),
      presenter: this.presenter,
      analytics: this.analytics,
      onEditPhone: $.proxy(this._onEditPhone, this)
    }, 'page');

    // Get History
    this._history = new History();

    // make Cancel link do browser back behaviour instead when fs_loans exist
    if (this.presenter.models.money && this.presenter.models.money.loans && typeof this.presenter.models.money.loans.fs_loans !== 'undefined') {
      $(this.node).find('.js-cancel-link').on('click', $.proxy(this._doCancelLink, this));
    }
    this._fsButtons();
    this._legalDisclaimer();
  };

  this.initAllReady = function () {
    this._super();

    // This page serves both onboarding and the legacy pre-application flow, and each
    // needs a different Done destination. In onboarding, hand off to the coordinator
    // rather than the markup's /loan/apply/continue href, which is decided from the
    // legacy fs_loans models. https://mogofintech.atlassian.net/browse/LLP-577
    this._isOnboardingFlow = this.isStepInActiveOnboarding('phone_verification');
    if (this._isOnboardingFlow) {
      $("a[data-mogo-ui='Button']", this.verifiedSection).on('click', $.proxy(this._onDoneInOnboarding, this));
    }
  };

  this._onDoneInOnboarding = function (e) {
    e.preventDefault();
    this.routeToNextStep(); // _OnboardingCoordinator
  };

  this._fsButtons = function () {
    // any buttons clicked should be switched to loading state
    $(this.node).find("a[data-mogo-ui='Button']").click(function () {
      $(this).mogo().setLoadState();
    });
    $(window).on('pageshow.fs-buttons', function (ev) {
      // specifically for safari back-forward cache
      if (ev.originalEvent.persisted) {
        // find all loading buttons and remove loading state
        $("a[data-mogo-ui='Button'].button-loading").mogo().removeLoadState();
      }
    });
  };

  this._legalDisclaimer = function () {
    $('.js--legal-disclaimer', this.node).mogo().create('LegalDisclaimer', {
      legal: $('[data-legal]:visible', this.node),
      presenter: this.presenter
    });
  };

  this.initPage = function () {
    this.analytics.pushEvent('virtual-page-view');
  };

  this._doCancelLink = function (e) {
    if (this.presenter.models.money && this.presenter.models.money.loans && (this.presenter.models.money.loans.fs_loans.loans || this.presenter.models.money.loans.fs_loans.loan_application)) {
      e.preventDefault();
      var cancelLink = $(this.node).find('.js-cancel-link')[0];
      this._history.disableHistoryNode(cancelLink);
      window.history.back();
    }
    // else do the usual.
  };

  this._onComplete = function () {
    this.verifiedSection.delay(50).slideDown();
  };

  this._onEditPhone = function () {
    $('.form-wizard__success', this.node).slideUp();
  };

  this.destroy = function () {
    $(window).off('pageshow.fs-buttons');
    if (this.verifiedSection) this.verifiedSection.mogo().destroy();
  };
}